import { Component, Input, OnInit, OnChanges, SimpleChanges, HostBinding } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EnfafIconComponent } from '../enfaf-icon/enfaf-icon.component';

@Component({
    selector: 'enfaf-input-suffix',
    imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    EnfafIconComponent
],
    templateUrl: './enfaf-input-suffix.component.html',
    styleUrls: ['./enfaf-input-suffix.component.scss']
})
export class EnfafInputSuffixComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() placeholder: string = '';
  @Input() autocomplete: string = 'off';
  @Input() errorLabel: string = '';
  @Input() type: string = 'text'; // Puede ser 'text', 'password', 'email', 'number', etc.
  @Input() control: any;
  @Input() min: any; // Para inputs de tipo number: valor mínimo
  @Input() max: any; // Para inputs de tipo number: valor máximo
  @Input() step: number | string = 'any'; // Para inputs de tipo number: incremento (ej: 1, 0.1, 'any')
  @Input() showNumberSpinners: boolean = false; // Para inputs de tipo number: mostrar controles de incremento/decremento
  @Input() iconSuffix: { icon: string; color: string; click: () => void } | undefined;
  @Input() color: 'dark' | 'light' = 'dark';
  @Input() description?: string;
  @Input() suffixIcon?: string;
  @Input() suffixText?: string;
  @Input() iconSize?: string = '24px';

  @HostBinding('class.light')
  get isLight() {
    return this.color === 'light';
  }

  @HostBinding('class.show-spinners')
  get shouldShowSpinners() {
    return this.showNumberSpinners;
  }

  get hasOtherErrors() {
    return this.control.hasError('invalidAge');
  }

  get hasValue() {
    return this.control && this.control.value !== null && this.control.value !== '';
  }

  hidePassword: boolean = true;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    // Implementación vacía por ahora
  }

  ngOnInit(): void {
    // Implementación vacía por ahora
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
    this.type = this.hidePassword ? 'password' : 'text';
  }
}
